export default __webpack_public_path__ + "static/media/prev-artisanpro.1fcb2ea9.jpg";